import protoRoot from "@/proto/proto";
import { websocketsend } from './websocket'
import global from '@/utils/global'
import { setOsData } from '@/utils/systemVersion.js'

function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  })
}
export function connect() {
  const PBMessageRequest = protoRoot.lookup(
    "com.lawback.push.core.pb.Connect"
  );
  if (!sessionStorage.getItem('deviceId')) {
    sessionStorage.setItem('deviceId', guid(), -1)
  }
  let os = {};
  setOsData(os);
  let osVersionName = os.osName
  const uid = sessionStorage.getItem('deviceId') || '';
  let rep = PBMessageRequest.create({
    clientVersion: "v1.4",
    deviceId: uid + '',//TODO 使用uuid，并永久缓存，存在则使用原来的，没有则生成一个
    osName: 'windows',
    osVersion: osVersionName,
    heartbeat: 10
  });
  return websocketsend(packet(4, PBMessageRequest.encode(rep).finish()))
}


//登录
export function webSocketLogin(userInfo, token) {
  let params = {
    bid: "lh",
    uid: userInfo && userInfo.uid + '' || sessionStorage.getItem('deviceId'),
    phone: userInfo && userInfo.phone,
    token: token
  }
  const PBMessageRequest = protoRoot.lookup(
    "com.lawback.push.core.pb.BindUser"
  );
  let rep = PBMessageRequest.create(params);
  console.log("登录websoket",rep)
  global.websocketIsLogin = true;
  return websocketsend(packet(100, PBMessageRequest.encode(rep).finish()))
}

//登出
export function webSocketQrLogin() {
  // debugger
  // if (!code) {
  //   return
  // }
  let uid = $nuxt.$cookies.get('userInfo').uid
  const PBMessageRequest = protoRoot.lookup(
    "com.lawback.push.core.pb.UnBindUser"
  );
  let rep = PBMessageRequest.create({
    bid: "lh",
    uid: uid + ''
  });
  // //console,log('sys', "登出====== ");
  global.websocketIsLogin = true;
  return websocketsend(packet(101, PBMessageRequest.encode(rep).finish()))
}



//发送聊天室消息
export function webSocketChatRoomMessage(roomInfo,type, msg) {
  console.log("发送聊天消息前",roomInfo,type, msg)
  const PBMessageRequest = protoRoot.lookup(
    "com.lawback.push.core.pb.ChatRoomMessage"
  );
  let params = {
    roomId: roomInfo.id, //房间ID int64
    fromUid: roomInfo.uid, //来自于哪个用户ID string
    msgType:type, //消息类型：text,pic,audio,video,position,file,tips,link
  }
  params.msg = msg;
  let rep = PBMessageRequest.create(params);
  console.log("聊天消息发送",rep)
  return websocketsend(packet(103, PBMessageRequest.encode(rep).finish()))
}

//进入聊天室
export function webSocketEnterChatRoom(roomInfo) {
  const PBMessageRequest = protoRoot.lookup(
    "com.lawback.push.core.pb.EnterChatRoom"
  );
  let rep = PBMessageRequest.create({
    roomId: roomInfo.id,
    ext: null
  });
  console.log("登陆聊天室",roomInfo)
  return websocketsend(packet(104, PBMessageRequest.encode(rep).finish()))
}

//退出聊天室
export function webSocketLeaveChatRoom() {
  const PBMessageRequest = protoRoot.lookup(
    "com.lawback.push.core.pb.LeaveChatRoom"
  );
  let rep = PBMessageRequest.create({
    roomId: 1,
    ext: null
  });
  return websocketsend(packet(105, PBMessageRequest.encode(rep).finish()))
}

export function webSocketExitLogin() {
  const PBMessageRequest = protoRoot.lookup(
    "com.lawback.push.core.pb.UnBindUser"
  );
  let rep = PBMessageRequest.create({
    bid: "lh",
    uid: userInfo.uid + '',
    phone: userInfo.phone,
    token: token
  });
  // //console,log('sys', "登出");
  global.websocketIsLogin = false;
  return websocketsend(packet(global.websocketIDs.loginOutId, PBMessageRequest.encode(rep).finish()))
}

//心跳
export function heart() {
  const PBMessageRequest = protoRoot.lookup(
    "com.lawback.push.core.pb.Connect"
  );
  let rep = PBMessageRequest.create({});
  return websocketsend(packet(0, PBMessageRequest.encode(rep).finish()));
}

export function webSocketUpdatePwd() {
  const PBMessageRequest = protoRoot.lookup(
    "package com.lawback.push.core.pb"
  );
  let rep = PBMessageRequest.create({});
  // //console,log('sys', "修改密码");
  return websocketsend(packet(global.websocketIDs.updatePwd, PBMessageRequest.encode(rep).finish()));
}


function parseLong(value) {
  return new Uint8Array([value >> 56 & 0xff, value >> 48 & 0xff, value >> 40 & 0xff, value >> 32 & 0xff, value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff]);
}


function parseInt(value) {
  return new Uint8Array([value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff]);
}

function parseShort(value) {
  return new Uint8Array([value >> 8 & 0xff, value & 0xff]);
}

function parseByte(value) {
  return new Uint8Array([value & 0xff]);
}


function packetHead(cmd, size) {
  let head = new Uint8Array(13);
  head.set(parseInt(size));//body长度（4个字节，不包含头的长度）
  head.set(parseByte(cmd), 4);//命令（1个字节）
  head.set(parseShort(0), 5);//校验位（2个字节，目前不处理）
  head.set(parseByte(0), 7);//标志位（1个字节，是否压缩，加密等，目前不处理）
  head.set(parseInt(0), 8);//sessionId(4个字节,标识是那条消息)
  head.set(parseByte(0), 12);//校验，纵向冗余校验。只校验head
  return head;
}

function packetBody(bodyObj) {
  return bodyObj;
}

//请求头：body长度（4个字节，不包含头的长度）+ 命令（1个字节）+校验位（2个字节，目前不处理）+标志位（1个字节，是否压缩，加密等，目前不处理）+sessionId(4个字节,标识是那条消息)

//发送数据拼接转换
function packet(cmd, bodyObj) {
  let body = packetBody(bodyObj);
  let head = packetHead(cmd, body.length);
  let toP = new Uint8Array(body.length + head.length);
  toP.set(head);
  toP.set(body, head.length);
  // //console,log(head, body, toP);
  return new Buffer(toP);
}



